import React, {Component} from 'react';
import { Container, Row, Col } from 'reactstrap';
import { sendData } from '../../analytics/sendData';
import { FormattedMessage } from 'react-intl';
import {config} from './../../constants/domainConfig'
import { isGamiclub } from '../../constants/isGamiclub';

class NewPrivacyPolicy extends Component {
    state = {
        showCookiePolicy: false
    }
	componentDidMount() {
        sendData('', '', '', 'viewed', { page: 'privacy-policy' });
		window.scrollTo(0, 0);
    }
    
    toggleCookiePolicy = () => {
        this.setState((prevState) => ({
            showCookiePolicy: !prevState.showCookiePolicy
        }))
    }

	render() {
        return (
			<section className="terms privacy-policy">
				<Container fluid>
					<Row>
					
                    	<Col xs="12">
							<div className="terms-title-wrap">
								<h2 className="terms-section-title">
                                <FormattedMessage id="newPrivacyPolicyTitle"
                                    defaultMessage="Privacy Policy"
                                />
                                </h2>
							</div>
						</Col>
                    
                        <Col xs="12">
                            <div className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyHead"
                                    defaultMessage="This Application collects some Personal Data from its Users. This document can be printed for reference by using the print command in the settings of any browser."
                                />
                            </div>
                        </Col>
					
                    </Row>

					<Row className="no-gutters">
                        
                        <Col xs="12" className="terms-list">    
                            <h6 className="terms-title">
                                <FormattedMessage id="newPrivacyPolicyOwner" 
                                defaultMessage="Owner and Data Controller"
                                />:
                            </h6>
                            <p className="terms-para">
                                <ul>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyOwner1"
                                            defaultMessage="Mobimilia BV"
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyOwner2"
                                            defaultMessage="Van Diemenstraat 140"
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyOwner3"
                                            defaultMessage="1013 CN Amsterdam"
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyOwner4"
                                            defaultMessage="Owner contact email: info@mobimilia.com"
                                        />
                                    </li>
                                </ul>
                            </p>
                        </Col>
                        
                        <Col xs="12" className="terms-list">    
                            <h6 className="terms-title">
                                <FormattedMessage id="newPrivacyPolicyDataCollected" 
                                defaultMessage="Types of Data collected"
                                />:
                            </h6>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyDataCollected1"
                                            defaultMessage="Among the types of Personal Data that this Application collects, by itself or through third parties, there are: Cookies; Usage Data; unique device identifiers for advertising (Google Advertiser ID or IDFA, for example)."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyDataCollected2"
                                            defaultMessage="Complete details on each type of Personal Data collected are provided in the dedicated sections of this privacy policy or by specific explanation texts displayed prior to the Data collection."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyDataCollected3"
                                            defaultMessage="Personal Data may be freely provided by the User, or, in case of Usage Data, collected automatically when using this Application."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyDataCollected4"
                                            defaultMessage="Unless specified otherwise, all Data requested by this Application is mandatory and failure to provide this Data may make it impossible for this Application to provide its services. In cases where this Application specifically states that some Data is not mandatory, Users are free not to communicate this Data without consequences to the availability or the functioning of the Service."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyDataCollected5"
                                            defaultMessage="Users who are uncertain about which Personal Data is mandatory are welcome to contact the Owner."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyDataCollected6"
                                            defaultMessage="Any use of Cookies – or of other tracking tools – by this Application or by the owners of third-party services used by this Application serves the purpose of providing the Service required by the User, in addition to any other purposes described in the present document and in the Cookie Policy, if available."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyDataCollected7"
                                            defaultMessage="Users are responsible for any third-party Personal Data obtained, published or shared through this Application and confirm that they have the third party's consent to provide the Data to the Owner."
                                        />
                                    </li>
                                </ul>
                            </p>
                        </Col>

                        <Col xs="12" className="terms-list">    
                            <h6 className="terms-title">
                                <FormattedMessage id="newPrivacyPolicyPurpose" 
                                defaultMessage="The purposes of processing"
                                />:
                            </h6>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyPurposeHead1"
                                    defaultMessage="The Data concerning the User is collected to allow the Owner to provide its Service, comply with its legal obligations, respond to enforcement requests, protect its rights and interests (or those of its Users or third parties), detect any malicious or fraudulent activity, as well as the following: Analytics, Remarketing and behavioral targeting, Advertising, Content performance and features testing (A/B testing) and Tag Management."
                                />{" "}
                                <FormattedMessage id="newPrivacyPolicyPurposeHead2"
                                    defaultMessage="For specific information about the Personal Data used for each purpose, the User may refer to the section “Detailed information on the processing of Personal Data”."
                                />
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfo"
                                        defaultMessage="Detailed information on the processing of Personal Data"
                                />
                            </p>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoHead"
                                    defaultMessage="Personal Data is collected for the following purposes and using the following services:"
                                />
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAdvertising"
                                    defaultMessage="Advertising"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAdvertising1"
                                            defaultMessage="This type of service allows User Data to be utilized for advertising communication purposes. These communications are displayed in the form of banners and other advertisements on this Application, possibly based on User interests."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAdvertising2"
                                            defaultMessage="This does not mean that all Personal Data are used for this purpose. Information and conditions of use are shown below."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAdvertising3"
                                            defaultMessage="Some of the services listed below may use Cookies or other Identifiers to identify Users or they may use the behavioral retargeting technique, i.e. displaying ads tailored to the User’s interests and behavior, including those detected outside this Application. For more information, please check the privacy policies of the relevant services."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAdvertising4"
                                            defaultMessage="In addition to any opt-out feature offered by any of the services below, Users may opt out by visiting the Network Advertising Initiative opt-out page."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAdvertising5"
                                            defaultMessage="Users may also opt-out of certain advertising features through applicable device settings, such as the device advertising settings for mobile phones or ads settings in general."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para" style={{marginLeft: '10px'}}>
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleIreland"
                                    defaultMessage="Google Ads Similar audiences (Google Ireland Limited)"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleIreland1"
                                            defaultMessage="Similar audiences is an advertising and behavioral targeting service provided by Google Ireland Limited that uses Data from Google Ads Remarketing in order to display ads to Users with similar behavior to Users who are already on the remarketing list due to their past use of this Application."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleIreland2"
                                            defaultMessage="On the basis of this Data, personalized ads will be shown to Users suggested by Google Ads Similar audiences. Users who don't want to be included in Similar audiences can opt out and disable the use of advertising cookies by going to: Google Ad Settings."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleIreland3"
                                            defaultMessage="Personal Data processed: Cookies; Usage Data."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedGoogleIreland4"
                                            defaultMessage="Place of processing: Ireland – Privacy Policy – Opt Out. Privacy Shield participant."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAnalytics"
                                    defaultMessage="Analytics"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAnalytics1"
                                            defaultMessage="The services contained in this section enable the Owner to monitor and analyze web traffic and can be used to keep track of User behavior."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para" style={{marginLeft: '10px'}}>
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland"
                                    defaultMessage="Google Analytics (Google Ireland Limited)"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland1"
                                            defaultMessage="Google Analytics is a web analysis service provided by Google Ireland Limited (“Google”). Google utilizes the Data collected to track and examine the use of this Application, to prepare reports on its activities and share them with other Google services."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland2"
                                            defaultMessage="Google may use the Data collected to contextualize and personalize the ads of its own advertising network."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland3"
                                            defaultMessage="Personal Data processed: Cookies; Usage Data."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAnalyticsIreland4"
                                            defaultMessage="Place of processing: Ireland – Privacy Policy – Opt Out. Privacy Shield participant."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para" style={{marginLeft: '10px'}}>
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAnalyticsDirect"
                                    defaultMessage="Analytics collected directly (this Application)"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAnalyticsDirect1"
                                            defaultMessage="This Application uses an internal analytics system that does not involve third parties."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAnalyticsDirect2"
                                            defaultMessage="Personal Data processed: Cookies; Usage Data."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para" style={{marginLeft: '10px'}}>
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous"
                                    defaultMessage="Google Analytics with anonymized IP (Google Ireland Limited)"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous1"
                                            defaultMessage="Google Analytics is a web analysis service provided by Google Ireland Limited (“Google”). Google utilizes the Data collected to track and examine the use of this Application, to prepare reports on its activities and share them with other Google services."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous2"
                                            defaultMessage="Google may use the Data collected to contextualize and personalize the ads of its own advertising network."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous3"
                                            defaultMessage="This integration of Google Analytics anonymizes your IP address. It works by shortening Users' IP addresses within member states of the European Union or in other contracting states to the Agreement on the European Economic Area. Only in exceptional cases will the complete IP address be sent to a Google server and shortened within the US."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous4"
                                            defaultMessage="Personal Data processed: Cookies; Usage Data."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoAnalyticsAnonymous5"
                                            defaultMessage="Place of processing: Ireland – Privacy Policy – Opt Out. Privacy Shield participant."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para" style={{marginLeft: '10px'}}>
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAds"
                                    defaultMessage="Google Ads conversion tracking (Google Ireland Limited)"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAds1"
                                            defaultMessage="Google Ads conversion tracking is an analytics service provided by Google Ireland Limited that connects data from the Google Ads advertising network with actions performed on this Application."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAds2"
                                            defaultMessage="Personal Data processed: Cookies; Usage Data."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAds3"
                                            defaultMessage="Place of processing: Ireland – Privacy Policy. Privacy Shield participant."
                                        />
                                    </li>
                                </ul>
                            </p>


                            <p className="terms-para" style={{marginLeft: '10px'}}>
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAdsReporting"
                                    defaultMessage="Google Analytics Advertising Reporting Features (Google Ireland Limited)"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAdsReporting1"
                                            defaultMessage="Google Analytics on this Application has Advertising Reporting Features activated, which collects additional information from the DoubleClick cookie (web activity) and from device advertising IDs (app activity). It allows the Owner to analyze specific behavior and interests Data (traffic Data and Users' ads interaction Data) and, if enabled, demographic Data (information about the age and gender). Users can opt out of Google's use of cookies by visiting Google's Ads Settings."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAdsReporting2"
                                            defaultMessage="Personal Data processed: Cookies; unique device identifiers for advertising (Google Advertiser ID or IDFA, for example); various types of Data as specified in the privacy policy of the service."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAdsReporting3"
                                            defaultMessage="Place of processing: Ireland – Privacy Policy – Opt Out. Privacy Shield participant."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para" style={{marginLeft: '10px'}}>
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleDemographics"
                                    defaultMessage="Google Analytics Demographics and Interests reports (Google Ireland Limited)"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleDemographics1"
                                            defaultMessage="Google Analytics Demographics and Interests reports is a Google Advertising Reporting feature that makes available demographic and interests Data inside Google Analytics for this Application (demographics means age and gender Data). Users can opt out of Google's use of cookies by visiting Google's Ads Settings."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleDemographics2"
                                            defaultMessage="Personal Data processed: Cookies; unique device identifiers for advertising (Google Advertiser ID or IDFA, for example)."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleDemographics3"
                                            defaultMessage="Place of processing: Ireland – Privacy Policy – Opt Out. Privacy Shield participant."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoABTesting"
                                    defaultMessage="Content performance and features testing (A/B testing)"
                                />:
                            </p>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoABTesting1"
                                    defaultMessage="The services contained in this section allow the Owner to track and analyze the User response concerning web traffic or behavior regarding changes to the structure, text or any other component of this Application."
                                />
                            </p>

                            <p className="terms-para" style={{marginLeft: '10px'}}>
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleOptimize"
                                    defaultMessage="Google Optimize (Google Ireland Limited)"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleOptimize1"
                                            defaultMessage="Google Optimize is an A/B testing service provided by Google Ireland Limited (Google). Google may use Personal Data to contextualize and personalize the ads of its own advertising network."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleOptimize2"
                                            defaultMessage="Personal Data processed: Cookies; Usage Data."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleOptimize3"
                                            defaultMessage="Place of processing: Ireland – Privacy Policy – Opt Out. Privacy Shield participant."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoRemarketing"
                                    defaultMessage="Remarketing and behavioral targeting"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoRemarketing1"
                                            defaultMessage="This type of service allows this Application and its partners to inform, optimize and serve advertising based on past use of this Application by the User."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoRemarketing2"
                                            defaultMessage="This activity is facilitated by tracking Usage Data and by using Cookies and other Identifiers to collect information which is then transferred to the partners that manage the remarketing and behavioral targeting activity."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoRemarketing3"
                                            defaultMessage="Some services offer a remarketing option based on email address lists."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoRemarketing4"
                                            defaultMessage="In addition to any opt-out feature provided by any of the services below, Users may opt out by visiting the Network Advertising Initiative opt-out page."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoRemarketing5"
                                            defaultMessage="Users may also opt-out of certain advertising features through applicable device settings, such as the device advertising settings for mobile phones or ads settings in general."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para" style={{marginLeft: '10px'}}>
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAdManagerExtenstion"
                                    defaultMessage="Google Ad Manager Audience Extension (Google Ireland Limited)"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAdManagerExtenstion1"
                                            defaultMessage="Google Ad Manager Audience Extension is a remarketing and behavioral targeting service provided by Google Ireland Limited that tracks the visitors of this Application and allows selected advertising partners to display targeted ads across the web to them."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAdManagerExtenstion2"
                                            defaultMessage="Personal Data processed: Cookies; Usage Data."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAdManagerExtenstion3"
                                            defaultMessage="Place of processing: Ireland – Privacy Policy – Opt Out. Privacy Shield participant."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para" style={{marginLeft: '10px'}}>
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAdRemarketing"
                                    defaultMessage="Google Ads Remarketing (Google Ireland Limited)"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAdRemarketing1"
                                            defaultMessage="Google Ads Remarketing is a remarketing and behavioral targeting service provided by Google Ireland Limited that connects the activity of this Application with the Google Ads advertising network and the DoubleClick Cookie. Users can opt out of Google's use of cookies for ads personalization by visiting Google's Ads Settings."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAdRemarketing2"
                                            defaultMessage="Personal Data processed: Cookies; Usage Data."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleAdRemarketing3"
                                            defaultMessage="Place of processing: Ireland – Privacy Policy – Opt Out. Privacy Shield participant."
                                        />
                                    </li>
                                </ul>
                            </p>


                            <p className="terms-para" style={{marginLeft: '10px'}}>
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleRemarketingwithAnalytics"
                                    defaultMessage="Remarketing with Google Analytics (Google Ireland Limited)"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleRemarketingwithAnalytics1"
                                            defaultMessage="Remarketing with Google Analytics is a remarketing and behavioral targeting service provided by Google Ireland Limited that connects the tracking activity performed by Google Analytics and its Cookies with the Google Ads advertising network and the Doubleclick Cookie."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleRemarketingwithAnalytics2"
                                            defaultMessage="Personal Data processed: Cookies; Usage Data."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleRemarketingwithAnalytics3"
                                            defaultMessage="Place of processing: Ireland – Privacy Policy – Opt Out. Privacy Shield participant."
                                        />
                                    </li>
                                </ul>
                            </p>


                            <p className="terms-para" style={{marginLeft: '10px'}}>
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoFacebookRemembering"
                                    defaultMessage="Facebook Remarketing (Facebook, Inc.)"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoFacebookRemembering1"
                                            defaultMessage="Facebook Remarketing is a remarketing and behavioral targeting service provided by Facebook, Inc. that connects the activity of this Application with the Facebook advertising network."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoFacebookRemembering2"
                                            defaultMessage="Personal Data processed: Cookies; Usage Data."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoFacebookRemembering3"
                                            defaultMessage="Place of processing: United States – Privacy Policy – Opt Out. Privacy Shield participant."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoTagManagement"
                                    defaultMessage="Tag Management"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoTagManagement1"
                                            defaultMessage="This type of service helps the Owner to manage the tags or scripts needed on this Application in a centralized fashion."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoTagManagement2"
                                            defaultMessage="This results in the Users' Data flowing through these services, potentially resulting in the retention of this Data."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para" style={{marginLeft: '10px'}}>
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleTagManager"
                                    defaultMessage="Google Tag Manager (Google Ireland Limited)"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleTagManager1"
                                            defaultMessage="Google Tag Manager is a tag management service provided by Google Ireland Limited."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleTagManager2"
                                            defaultMessage="Personal Data processed: Usage Data."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoGoogleTagManager3"
                                            defaultMessage="Place of processing: Ireland – Privacy Policy. Privacy Shield participant."
                                        />
                                    </li>
                                </ul>
                            </p>

                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData"
                                    defaultMessage="Further information about Personal Data"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData1"
                                            defaultMessage="Analysis and predictions based on the User’s Data (“profiling”)"
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData2"
                                            defaultMessage="The Owner may use the Personal and Usage Data collected through this Application to create or update User profiles. This type of Data processing allows the Owner to evaluate User choices, preferences and behaviour for the purposes outlined in the respective section of this document."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData3"
                                            defaultMessage="User profiles can also be created through the use of automated tools like algorithms, which can also be provided by third parties. To find out more about the profiling activities performed, Users can check the relevant sections of this document."
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyPurposeDetailedInfoFurtherInfoPersonalData4"
                                            defaultMessage="The User always has a right to object to this kind of profiling activity. To find out more about the User's rights and how to exercise them, the User is invited to consult the section of this document outlining the rights of the User."
                                        />
                                    </li>
                                </ul>
                            </p>
                        </Col>

                        <Col xs="12" className="terms-list">    
                            <h6 className="terms-title">
                                <FormattedMessage id="newPrivacyPolicyRights" 
                                    defaultMessage="The rights of Users"
                                />:
                            </h6>

                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyRightsPara1"
                                    defaultMessage="Users may exercise certain rights regarding their Data processed by the Owner."
                                />
                                <FormattedMessage id="newPrivacyPolicyRightsPara2"
                                    defaultMessage="In particular, Users have the right to do the following:"
                                />
                                <ul className="privacy-policy-lists">
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyRightsParaList1"
                                            defaultMessage="Withdraw their consent at any time. Users have the right to withdraw consent where they have previously given their consent to the processing of their Personal Data." 
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyRightsParaList2"
                                            defaultMessage="Object to processing of their Data. Users have the right to object to the processing of their Data if the processing is carried out on a legal basis other than consent. Further details are provided in the dedicated section below." 
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyRightsParaList3"
                                            defaultMessage="Access their Data. Users have the right to learn if Data is being processed by the Owner, obtain disclosure regarding certain aspects of the processing and obtain a copy of the Data undergoing processing." 
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyRightsParaList4"
                                            defaultMessage="Verify and seek rectification. Users have the right to verify the accuracy of their Data and ask for it to be updated or corrected." 
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyRightsParaList5"
                                            defaultMessage="Restrict the processing of their Data. Users have the right, under certain circumstances, to restrict the processing of their Data. In this case, the Owner will not process their Data for any purpose other than storing it." 
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyRightsParaList6"
                                            defaultMessage="Have their Personal Data deleted or otherwise removed. Users have the right, under certain circumstances, to obtain the erasure of their Data from the Owner." 
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyRightsParaList7"
                                            defaultMessage="Receive their Data and have it transferred to another controller. Users have the right to receive their Data in a structured, commonly used and machine readable format and, if technically feasible, to have it transmitted to another controller without any hindrance. This provision is applicable provided that the Data is processed by automated means and that the processing is based on the User's consent, on a contract which the User is part of or on pre-contractual obligations thereof." 
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="newPrivacyPolicyRightsParaList8"
                                            defaultMessage="Lodge a complaint. Users have the right to bring a claim before their competent data protection authority." 
                                        />
                                    </li>
                                </ul>
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyRightsDetails"
                                    defaultMessage="Details about the right to object to processing"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyRightsDetails1"
                                    defaultMessage="Where Personal Data is processed for a public interest, in the exercise of an official authority vested in the Owner or for the purposes of the legitimate interests pursued by the Owner, Users may object to such processing by providing a ground related to their particular situation to justify the objection."
                                /> 
                                <FormattedMessage id="newPrivacyPolicyRightsDetails2"
                                    defaultMessage="Users must know that, however, should their Personal Data be processed for direct marketing purposes, they can object to that processing at any time without providing any justification. To learn, whether the Owner is processing Personal Data for direct marketing purposes, Users may refer to the relevant sections of this document."
                                /> 
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyRightsExercise"
                                    defaultMessage="How to exercise these rights"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyRightsExercise1"
                                    defaultMessage="Any requests to exercise User rights can be directed to the Owner through the contact details provided in this document. These requests can be exercised free of charge and will be addressed by the Owner as early as possible and always within one month."
                                /> 
                            </p>
                        </Col>

                        <Col xs="12" className="terms-list">    
                            <h6 className="terms-title">
                                <FormattedMessage id="newPrivacyPolicyCookie" 
                                    defaultMessage="Cookie Policy"
                                />:
                            </h6>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyCookie1"
                                    defaultMessage="This Application uses Cookies and other Identifiers. To learn more, the User may consult the "
                                />
                                <span className="privacy-policy-lists-anchors" onClick={this.toggleCookiePolicy} style={{cursor: 'pointer'}}>
                                <FormattedMessage id="newPrivacyPolicyCookie2"
                                    defaultMessage="Cookie Policy."
                                />
                                </span>
                            </p>
                        </Col>


                        {this.state.showCookiePolicy ? <Col xs="12" className="terms-list">    
                            <h6 className="terms-title">
                                <FormattedMessage id="newPrivacyPolicyCookieGamelord" 
                                    defaultMessage="Cookie Policy of Game Lords"
                                />:
                            </h6>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyCookieGamelord1"
                                    defaultMessage="Cookies and other Identifiers consist of portions of code placed on the User’s device that assist the Owner in providing the Service according to the purposes described."
                                />
                            </p>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyCookieGamelord2"
                                    defaultMessage="Some of the purposes for which Identifiers are used may also require the User's consent. Whenever consent is given, it can be freely withdrawn at any time following the instructions provided in this document."
                                />
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyCookieActivities"
                                    defaultMessage="Activities strictly necessary for the operation of this Application and delivery of the Service"
                                />:
                            </p>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyCookieActivities1"
                                    defaultMessage="This Application uses Cookies or other Identifiers to carry out activities that are strictly necessary for the operation or delivery of the Service and, therefore, do not require Users to consent. Users can disable such Identifiers by modifying their browser or device settings as described in more detail within this document, but this may affect core operational functions or result in the unavailability of the Service."
                                />
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyCookieOtherActivities"
                                    defaultMessage="Other activities"
                                />:
                            </p>
                            <p className="terms-para">
                                <ul className="privacy-policy-lists">
                                    <li>
                                    <FormattedMessage id="newPrivacyPolicyCookieOtherActivitiesMeasurement"
                                        defaultMessage="Measurement"
                                    />:
                                      <p className="terms-para">
                                        <FormattedMessage id="newPrivacyPolicyCookieOtherActivitiesMeasurement1"
                                            defaultMessage="This Application uses Cookies or other Identifiers to measure traffic and analyze User behavior with the goal of improving the Service."
                                        />
                                    </p>
                                    </li>
                                    <ul className="privacy-policy-lists">
                                        <li>
                                                <FormattedMessage id="newPrivacyPolicyCookieOtherActivitiesMeasurementList1"
                                                    defaultMessage="Analytics"
                                                />       
                                        </li>
                                        <li>
                                                <FormattedMessage id="newPrivacyPolicyCookieOtherActivitiesMeasurementList2"
                                                    defaultMessage="Analytics services managed directly by this Application"
                                                />     
                                       </li>
                                        <li>
                                                <FormattedMessage id="newPrivacyPolicyCookieOtherActivitiesMeasurementList3"
                                                    defaultMessage="Anonymized analytics services"
                                                />       
                                        </li>
                                        <li>
                                                <FormattedMessage id="newPrivacyPolicyCookieOtherActivitiesMeasurementList4"
                                                    defaultMessage="Content performance and features testing (A/B testing)"
                                                />       
                                        </li>
                                    </ul>

                                    <li>
                                    <FormattedMessage id="newPrivacyPolicyCookieOtherActivitiesTargeting"
                                        defaultMessage="Targeting &amp; Advertising"
                                    />:
                                     <p className="terms-para">
                                        <FormattedMessage id="newPrivacyPolicyCookieOtherActivitiesTargeting1"
                                            defaultMessage="This Application uses Cookies or other Identifiers to deliver personalized marketing content based on User behavior and to operate, serve and track ads."
                                        />
                                    </p>
                                    </li>
                                    <ul className="privacy-policy-lists">
                                        <li>
                                                <FormattedMessage id="newPrivacyPolicyCookieOtherActivitiesTargetingList1"
                                                    defaultMessage="Analytics"
                                                />       
                                        </li>
                                        <li>
                                                <FormattedMessage id="newPrivacyPolicyCookieOtherActivitiesTargetingList2"
                                                    defaultMessage="Analytics services managed directly by this Application"
                                                />     
                                        </li>
                                    </ul>
                                </ul>
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyCookieWithdrawConstent"
                                    defaultMessage="How to provide or withdraw consent"
                                />:
                            </p>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyCookieWithdrawConstent1"
                                    defaultMessage="Users can provide or withdraw consent to the use of Cookies and other Identifiers by setting their preferences within the cookie notice or by updating such preferences via the relevant consent-preferences widget accordingly, if available."
                                />
                            </p>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyCookieWithdrawConstent2"
                                    defaultMessage="Additionally, Users can manage preferences regarding Identifiers directly from within their own device settings and prevent – for example – the storing of third-party Identifiers. It is also possible, via relevant browser or device features, to delete previously stored Identifiers, including those used to remember the User’s initial consent. Users can, for example, find information about how to manage Identifiers in the most commonly used browsers at the following addresses: Google Chrome, Mozilla Firefox, Apple Safari and Microsoft Internet Explorer."
                                />
                            </p>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyCookieWithdrawConstent3"
                                    defaultMessage="With regard to any Identifiers stored by third parties, Users can manage their preferences and withdraw their consent by clicking the related opt-out link (where provided), by using the means indicated in the third party's privacy policy, or by contacting the third party."
                                />
                            </p>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyCookieWithdrawConstent4"
                                    defaultMessage="Notwithstanding the above, Users are hereby informed that they may follow the instructions provided by YourOnlineChoices (EU), the Network Advertising Initiative (US) and the Digital Advertising Alliance (US), DAAC (Canada), DDAI (Japan) or other similar services. Such initiatives allow Users to select their tracking preferences for most of the advertising tools. The Owner thus recommends that Users make use of these resources in addition to the information provided in this document."
                                />
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyCookieController"
                                    defaultMessage="Owner and Data Controller"
                                />:
                            </p>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyCookieController1"
                                    defaultMessage="Mobimilia BV"
                                />
                                <br />
                                <FormattedMessage id="newPrivacyPolicyCookieController2"
                                    defaultMessage="Van Diemenstraat 140"
                                />
                                <br />
                                <FormattedMessage id="newPrivacyPolicyCookieController3"
                                    defaultMessage="1013 CN Amsterdam"
                                />
                                <br />
                                <FormattedMessage id="newPrivacyPolicyCookieController4"
                                    defaultMessage="Owner contact email: info@mobimilia.com"
                                />
                            </p>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyCookieController5"
                                    defaultMessage="Since the storing of third-party Cookies and other Identifiers through the services used within this Application cannot be technically controlled by the Owner, any specific references to Identifiers stored by third parties are to be considered indicative. In order to obtain complete information, the User is kindly requested to consult the privacy policies of the respective third-party services listed in this document."
                                />
                            </p>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyCookieController6"
                                    defaultMessage="Given the objective complexity surrounding technologies related to Cookies and other Identifiers, Users are encouraged to contact the Owner should they wish to receive any further information on the use of such Identifiers by this Application."
                                />
                            </p>
                          
                        </Col> : null}

                        <Col xs="12" className="terms-list">    
                            <h6 className="terms-title">
                                <FormattedMessage id="newPrivacyPolicyAddInfo" 
                                defaultMessage="Additional information about Data collection and processing"
                                />:
                            </h6>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyAddInfoLegalAction"
                                    defaultMessage="Legal action"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyAddInfoLegalAction1"
                                    defaultMessage="The User's Personal Data may be used for legal purposes by the Owner in Court or in the stages leading to possible legal action arising from improper use of this Application or the related Services."
                                /> 
                                <FormattedMessage id="newPrivacyPolicyAddInfoLegalAction2"
                                    defaultMessage="The User declares to be aware that the Owner may be required to reveal personal data upon request of public authorities."
                                /> 
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyAddInfoPersonalData"
                                    defaultMessage="Additional information about User's Personal Data"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyAddInfoPersonalData1"
                                    defaultMessage="In addition to the information contained in this privacy policy, this Application may provide the User with additional and contextual information concerning particular Services or the collection and processing of Personal Data upon request."
                                />
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyAddInfoMaintenance"
                                    defaultMessage="System logs and maintenance"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyAddInfoMaintenance1"
                                    defaultMessage="For operation and maintenance purposes, this Application and any third-party services may collect files that record interaction with this Application (System logs) use other Personal Data (such as the IP Address) for this purpose."
                                />
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyAddInfoNotContained"
                                    defaultMessage="Information not contained in this policy"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyAddInfoNotContained1"
                                    defaultMessage="More details concerning the collection or processing of Personal Data may be requested from the Owner at any time. Please see the contact information at the beginning of this document."
                                />
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyAddInfoDoNotTrack"
                                    defaultMessage="How “Do Not Track” requests are handled"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyAddInfoDoNotTrack1"
                                    defaultMessage="This Application does not support “Do Not Track” requests. To determine whether any of the third-party services it uses honor the “Do Not Track” requests, please read their privacy policies."
                                />
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyAddInfoChanges"
                                    defaultMessage="Changes to this privacy policy"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyAddInfoChanges1"
                                    defaultMessage="The Owner reserves the right to make changes to this privacy policy at any time by notifying its Users on this page and possibly within this Application and/or - as far as technically and legally feasible - sending a notice to Users via any contact information available to the Owner. It is strongly recommended to check this page often, referring to the date of the last modification listed at the bottom."
                                /> 
                                <FormattedMessage id="newPrivacyPolicyAddInfoChanges2"
                                    defaultMessage="Should the changes affect processing activities performed on the basis of the User’s consent, the Owner shall collect new consent from the User, where required."
                                /> 
                            </p>
                        </Col>

                        <Col xs="12" className="terms-list">    
                            <h6 className="terms-title">
                                <FormattedMessage id="newPrivacyPolicyDefiner" 
                                defaultMessage="Definitions and legal references"
                                />:
                            </h6>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyDefinerPersonalData"
                                    defaultMessage="Personal Data (or Data)"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyDefinerPersonalData1"
                                    defaultMessage="Any information that directly, indirectly, or in connection with other information — including a personal identification number — allows for the identification or identifiability of a natural person."
                                /> 
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyDefinerUsageData"
                                    defaultMessage="Usage Data"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyDefinerUsageData1"
                                    defaultMessage="Information collected automatically through this Application (or third-party services employed in this Application), which can include: the IP addresses or domain names of the computers utilized by the Users who use this Application, the URI addresses (Uniform Resource Identifier), the time of the request, the method utilized to submit the request to the server, the size of the file received in response, the numerical code indicating the status of the server's answer (successful outcome, error, etc.), the country of origin, the features of the browser and the operating system utilized by the User, the various time details per visit (e.g., the time spent on each page within the Application) and the details about the path followed within the Application with special reference to the sequence of pages visited, and other parameters about the device operating system and/or the User's IT environment."
                                />
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyDefinerUser"
                                    defaultMessage="User"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyDefinerUser1"
                                    defaultMessage="The individual using this Application who, unless otherwise specified, coincides with the Data Subject."
                                />
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyDefinerSubject"
                                    defaultMessage="Data Subject"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyDefinerSubject1"
                                    defaultMessage="The natural person to whom the Personal Data refers."
                                />
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyDefinerProcessor"
                                    defaultMessage="Data Processor (or Data Supervisor)"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyDefinerProcessor1"
                                    defaultMessage="The natural or legal person, public authority, agency or other body which processes Personal Data on behalf of the Controller, as described in this privacy policy."
                                />
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyDefinerController"
                                    defaultMessage="Data Controller (or Owner)"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyDefinerController1"
                                    defaultMessage="The natural or legal person, public authority, agency or other body which, alone or jointly with others, determines the purposes and means of the processing of Personal Data, including the security measures concerning the operation and use of this Application. The Data Controller, unless otherwise specified, is the Owner of this Application."
                                /> 
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyDefinerApplication"
                                    defaultMessage="This Application"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyDefinerApplication1"
                                    defaultMessage="The means by which the Personal Data of the User is collected and processed."
                                /> 
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyDefinerService"
                                    defaultMessage="Service"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyDefinerService1"
                                    defaultMessage="The service provided by this Application as described in the relative terms (if available) and on this site/application."
                                /> 
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyDefinerEU"
                                    defaultMessage="European Union (or EU)"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyDefinerEU1"
                                    defaultMessage="Unless otherwise specified, all references made within this document to the European Union include all current member states to the European Union and the European Economic Area."
                                /> 
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyDefinerCookies"
                                    defaultMessage="Cookies"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyDefinerCookies1"
                                    defaultMessage="Small sets of data stored in the User's device."
                                /> 
                            </p>
                            <p className="terms-para-head">
                                <FormattedMessage id="newPrivacyPolicyDefinerLegalInfo"
                                    defaultMessage="Legal information"
                                />:
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyDefinerLegalInfo1"
                                    defaultMessage="This privacy statement has been prepared based on provisions of multiple legislations, including Art. 13/14 of Regulation (EU) 2016/679 (General Data Protection Regulation)."
                                /> 
                            </p>
                            <p className="terms-para" style={{marginLeft: '30px'}}>
                                <FormattedMessage id="newPrivacyPolicyDefinerLegalInfo2"
                                    defaultMessage="This privacy policy relates solely to this Application, if not stated otherwise within this document."
                                /> 
                            </p>
                        </Col>
                        <Col>
                            <p className="terms-para">
                                <FormattedMessage id="newPrivacyPolicyLatestUpdate"
                                    defaultMessage="Latest update: May 08, 2020"
                                /> 
                            </p>
                        </Col>
					</Row>
				</Container>
			</section>

		);

	}

}

export default NewPrivacyPolicy;



// WEBPACK FOOTER //
// ./src/components/NewPrivacyPolicy/NewPrivacyPolicy.js